import type { RichTextEntryType } from 'tsconfig/types';
import * as htmlparser2 from 'htmlparser2';
import render from 'dom-serializer';
import type { ChildNode, Element } from 'domhandler';

/**
 * Traverse parsed DOM nodes and add `richtext-background` class
 * to any element whose inline style contains "background".
 */
const traverseNodes = (nodes: ChildNode[]): void => {
  for (const node of nodes) {
    if (node.type === 'tag') {
      const el = node as Element;
      const style = el.attribs?.style || '';
      if (style.includes('background')) {
        const existingClass = el.attribs?.class || '';
        el.attribs.class = existingClass ? `richtext-background ${existingClass}` : 'richtext-background';
      }
      if (el.children?.length) {
        traverseNodes(el.children);
      }
    }
  }
};

/**
 * Adds `richtext-background` class to elements whose inline style contains "background".
 * Uses htmlparser2 + dom-serializer — works in SSG, SSR, and CSR (no browser APIs needed).
 */
export const parseHtmlContent = (htmlContent: string): string => {
  if (!htmlContent) {
    return htmlContent;
  }

  const dom = htmlparser2.parseDocument(htmlContent);
  traverseNodes(dom.children);
  return render(dom);
};

export function contentToSanitize(contentItem: RichTextEntryType): string {
  return typeof contentItem?.fields?.content === 'string' && contentItem?.fields?.content.replace(/<[^>]*>/g, '').trim()
    ? contentItem?.fields?.content
    : '';
}
